import { render, staticRenderFns } from "./editHotline.vue?vue&type=template&id=2b6e1915&scoped=true&"
import script from "./editHotline.vue?vue&type=script&lang=js&"
export * from "./editHotline.vue?vue&type=script&lang=js&"
import style0 from "./editHotline.vue?vue&type=style&index=0&id=2b6e1915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e1915",
  null
  
)

export default component.exports